import React from 'react';
import Header from './components/main/Header';
import Footer from './components/main/Footer';
import { Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Services from './components/pages/Services';
import FAQ from './components/pages/FAQ';
import Contact from './components/pages/Contact';
import ScrollToTop from "./components/ScrollToTop";
import NotFound from './components/pages/NotFound';
import Quote from "./components/pages/Quote";
import Top from './components/Top';
import Claims from './components/pages/Claims';

const App = () => {


    return (
        <>
            <Header />
            <Top />
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/about' element={<About />} />
                <Route path='/services' element={<Services />} />
                <Route path='/faq' element={<FAQ />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/quote' element={<Quote />} />
                <Route path='/claims' element={<Claims />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <ScrollToTop />
            <useScrollAnimation />
        </>
    );
};

export default App;
